import CustomTextLink from './custom-text-link';

export default CustomTextLink;
